var axios = require("axios");

const getChatMessages = (fromUserId, successCallback, errorCallback) => {
  const url = `chat/get-messages`;
  const data = { senderId: Number(fromUserId) };
  let config = {
    method: "post",
    url: url,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "Content-Type": "application/json",
    },
    data,
  };
  axios(config)
    .then(function (response) {
      // console.log(response)
      successCallback && successCallback(response);
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error);
    });
};

const getLatestChats = (successCallback, errorCallback) => {
  const url = `/get-conversations`;
  let config = {
    method: "get",
    url: url,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "Content-Type": "application/json",
    },
  };
  axios(config)
    .then(function (response) {
      // Adapt new conversations payload to legacy consumer shape (ChatPanel.loadLatestChats)
      const conversations = (response && response.data && Array.isArray(response.data.data)) ? response.data.data : [];
      const mapped = conversations.map((c) => {
        const other = c && c.otherUser ? c.otherUser : {};
        return {
          userId: other.id,
          user: {
            id: other.id,
            username: other.username,
            avatarImageUrl: other.avatarImageUrl,
          },
          unreadCount: Number(c && c.unreadCount) || 0,
          lastMessage: c && c.lastMessage ? c.lastMessage : null,
          // Not used by current consumer path when userId !== currentUserId
          senderId: null,
          sender: null,
        };
      });
      const adapted = { ...response, data: { ...(response.data || {}), data: mapped } };
      successCallback && successCallback(adapted);
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error);
    });
};


const getPrivateMessages = (otherUserId, page = 0, perPage = 50, successCallback, errorCallback) => {
  const url = `/get-private-messages`;
  const data = {
    other_user_id: Number(otherUserId),
    page: Number(page),
    'per-page': Number(perPage),
  };
  const config = {
    method: 'post',
    url,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    },
    data
  };

  axios(config)
    .then(function (response) {
      successCallback && successCallback(response.data);
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error);
    });
}


export const chatFetcher = {
  getPrivateMessages,
  getChatMessages,
  getLatestChats,
};
